/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: BSSummaryPhase.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
namespace WinAnimation.Phase {
    import Utils = Util.Utils;

    export class BSSummaryPhase extends BSIdlePhase {
        protected summaryTimer:Phaser.Timer;
        protected soundId:string;
        /**
        * BSSummaryPhase is inherited class of SummaryPhase.
        * @author <a href=mailto:SNethani@Gauselmann.com>Sujata Nethani</a>
        * $Date: 3 July 2020 $     
        */
        start(finishCallback: (...args) => any, context?: any, priority?: any, ...args): void {
            this.onComplete.addOnce(finishCallback, context, priority, ...args);
            
            if (this.summaryTimer == null) {
                this.summaryTimer = Utils.getTimer();
            }
            let duration: number = 0;
            if(this.lineTimer==null) {
                this.lineTimer = Utils.getTimer();
            }
            if(this.linesToAnimate.length > 0) {
                this.soundId = this.determineSoundForResult(this.gameResult);
                duration = Sounds.SoundManager.play(this.soundId).durationMS;
                this.unlightAllLines();
                this.darkenReels();
                this.startCycling();
            }       
                
            this.summaryTimer.add(duration, this.onFinished, this);
            this.summaryTimer.start();
        }
        
        protected determineSoundForResult(gameResult:DTO.GameResult):string {
            if(this.winAnimation.activeLineSet) {
                let numOfLines:number = this.winAnimation.activeLineSet.getSize();
                for(let i=0,sound; sound = this.triggerSounds[i]; i++) {
                    if(sound.isTriggeredBy(gameResult, 0, {numberOfActiveLines: numOfLines,response:this.response})) {
                        return sound.getSoundId();
                    }
                }
            }
            return "";
        }
        
        pause(): void {
            super.pause();
            if (this.summaryTimer) {
                this.summaryTimer.pause();
            }            
            if (Sounds.SoundManager.getSound(this.soundId)) {
                Sounds.SoundManager.getSound(this.soundId).pause();
            }
        }

        resume(): void {
            super.resume();
            if (this.summaryTimer) {
                this.summaryTimer.resume();
            }            
            if (Sounds.SoundManager.getSound(this.soundId)) {
                Sounds.SoundManager.getSound(this.soundId).resume();
            }
        }
        
        onFinished() {
            if (Sounds.SoundManager.getSound(this.soundId)) {
                Sounds.SoundManager.getSound(this.soundId).stop();
            }
            super.onFinished();
        }
    }
}

